module.exports = __webpack_public_path__ + "static/media/plane(5).ceb18072.PNG";